module.exports = __webpack_public_path__ + "img/cup.3362064e.png";